import { render, staticRenderFns } from "./Generation.vue?vue&type=template&id=c4afb5c0&"
import script from "./Generation.vue?vue&type=script&lang=js&"
export * from "./Generation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports